import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import User from "layouts/User";

import { Jobs, Search } from "./components";
import { urls, mimeType, httpCodes } from "constants/urls";
import { per } from "constants/pagination";
import { Loading } from "shared/Loading";

const UserJobs = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const terms = params.get("terms") || "";

  const [searchParams, setSearchParams] = useState({
    terms,
    page: 0,
    sortOn: "",
    sortDir: "",
    per,
  });
  const [loading, setLoading] = useState(true);
  const [jobsData, setJobsData] = useState([]);
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("token");
    const params = new URLSearchParams({
      page: searchParams.page,
      terms: searchParams.terms,
      sort_on: searchParams.sortOn,
      sort_dir: searchParams.sortDir,
      per: searchParams.per,
    });

    fetch(`${urls.jobs}?${params}`, {
      method: "GET",
      headers: {
        Accept: mimeType,
        "Content-Type": mimeType,
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then(({ data, meta }) => {
        setJobsData(data);
        setMeta(meta);
        setLoading(false);
      })
      .catch((response) => {
        datadogRum.addError(response);
        if (response.status === httpCodes.unauthorized) {
          navigate("/sign-out");
        }
      });
  }, [searchParams, navigate]);

  return (
    <User>
      <Box
        position={"relative"}
        minHeight={"calc(100vh - 247px)"}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"center"}
        height={1}
        sx={{ p: theme.spacing(4) }}
      >
        <Grid container spacing={6}>
          <Grid item container>
            <Typography variant={"h4"}>Jobs</Typography>
          </Grid>
          <Grid item container>
            <Search
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              setLoading={setLoading}
            />
          </Grid>
          <Grid item container>
            {loading ? (
              <Loading />
            ) : (
              <Jobs
                jobsData={jobsData}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                meta={meta}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </User>
  );
};

export default UserJobs;
